import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export const ListingPropertyBadges: React.FC = () => {
  const { featuredMessages } = usePropertyListing();

  if (!(featuredMessages?.length > 0)) {
    return null;
  }

  return (
    <UitkSpacing padding={{ blockend: 'one' }}>
      <div role="list" data-stid="property-structure-type" className="uitk-cell all-cell-1-1">
        <UitkLayoutFlex space="one" alignItems="center">
          {featuredMessages.map((msg, index) => (
            <UitkLayoutFlexItem key={msg.value}>
              <div>
                <UitkLayoutFlex space="one" alignItems="center">
                  {index !== 0 && (
                    <UitkLayoutFlexItem>
                      <UitkText aria-hidden="true" weight="bold" size={300} className="separator">
                        ·
                      </UitkText>
                    </UitkLayoutFlexItem>
                  )}
                  {msg.icon && (
                    <UitkLayoutFlexItem>
                      <div>
                        <UitkIcon name={msg.icon?.id} size={UitkIconSize.SMALL} className="pwa-theme--grey-700" aria-hidden="true" />
                      </div>
                    </UitkLayoutFlexItem>
                  )}
                  <UitkLayoutFlexItem>
                    <div role="listitem" className="uitk-type-regular pwa-theme--grey-700 uitk-type-300" data-stid="property-badge">
                      {msg.value}
                    </div>
                  </UitkLayoutFlexItem>
                </UitkLayoutFlex>
              </div>
            </UitkLayoutFlexItem>
          ))}
        </UitkLayoutFlex>
      </div>
    </UitkSpacing>
  );
};
ListingPropertyBadges.displayName = 'ListingPropertyBadges';
